import env from "./env.js";
let api_root = env.api_root
let api_root_v1 = env.api_root + 'v1/'
let weixinOriginalId = env.weixinOriginalId

let api = {
	weixinOriginalId: weixinOriginalId, //微信小程序的原始id
	default: { // 默认
		register: api_root_v1 + 'user/identity/register',
		login: api_root_v1 + 'user/identity/login',
		logout: api_root_v1 + 'user/identity/logout',
		upload: api_root_v1 + 'file/upload',
		payType: api_root_v1 + 'payment/get-pay-type',
		getImgBase64: api_root_v1 + 'mall/get-img-base64',
		posterIndex: api_root_v1 + 'poster/index',
		buyingPoint: api_root_v1 + 'mall/buying-point',
		privacyPolicy: api_root_v1 + 'user/user/user-agree',
		cancellation: api_root_v1 + 'user/identity/cancellation'
	},
	index: {
		config: api_root_v1 + 'mall/config',
		diyIndex: api_root_v1 + 'diy/index',
		getComponentsData: api_root_v1 + 'diy/get-components-data', // 获取 商品分类 - 订单播报}
	},
	device:{
		index: api_root_v1 + 'device/index',
		deviceedit: api_root_v1 + 'device/device-edit',
		devicestatitic:api_root_v1 + 'device/device-statitic',
		plantatitic:api_root_v1 + 'device/plan-statitic',
		getdevicelist:api_root_v1 + 'device/getdevicelist',
		plan: api_root_v1 + 'device/plan',
		planedit: api_root_v1 + 'device/plan-edit',
		deviceuse:api_root_v1 + 'device/device-use',
		getdevicedetail:api_root_v1 + 'device/get-device-detail',
		cmd:api_root_v1 + 'device/cmd',
		monthIndex:api_root_v1 + 'device/month-index',
		updatedevice:api_root_v1 + 'device/update-device',
	},
	user: { // 用户中心
		searchUser: api_root_v1 + 'user/user/get-user',
		jssdkConfig: api_root_v1 + 'user/identity/jssdk-config',
		miniLogin: api_root_v1 + 'user/identity/mini-login',
		bind: api_root_v1 + 'user/identity/bind',
		authPhone: api_root_v1 + 'user/identity/auth-phone',
		appAuthLogin: api_root_v1 + 'user/identity/app-auth-login',
		authLogin: api_root_v1 + 'user/identity/auth-login',
		smsCode: api_root_v1 + 'user/identity/register-sms-code',
		userInfo: api_root_v1 + 'user/user/user-info',
		updateInfo: api_root_v1 + 'user/user/update-data',
		transactionPwd: api_root_v1 + 'user/user/set-transaction-password',
		address: api_root_v1 + 'user/user/user-address-list',
		addressInfo: api_root_v1 + 'user/user/address-info',
		townList: api_root_v1 + 'user/user/get-town-list',
		addressSave: api_root_v1 + 'user/user/user-address-save',
		addressDetail: api_root_v1 + 'user/user/user-address-detail',
		addressDelete: api_root_v1 + 'user/user/user-address-delete',
		memberBenefitList: api_root_v1 + 'user/user/member-benefit-list',
		rechargeConfig: api_root_v1 + 'user/user/recharge-config',
		collectList: api_root_v1 + 'user/user/collect-list',
		loginPwd: api_root_v1 + 'user/user/set-login-password',
	},
	template:{
		TemplateSetting:api_root_v1 + 'article/template/template-setting',
		CatsList:api_root_v1 + 'article/template/cats-list',
	},
	article:{
		list:api_root_v1 + 'article/article/list',
		article:api_root_v1 + 'article/article/article',
		getclick:api_root_v1 +'article/article/click',
		getconnect:api_root_v1 +'article/article/getconnect',
		iscopy:api_root_v1 +'article/article/iscopy',
		index:api_root_v1 + 'article/article/index',
	},
	cate:{
		list:api_root_v1 + 'article/cate/list',
		cateList:api_root_v1 + 'article/cate/cate-list',
		article:api_root_v1 + 'article/cate/article',
		detail:api_root_v1 +'article/cate/detail',
	},
	message:{
		submit:api_root_v1 + 'article/message/submit',
	},
	report:{
		product:api_root_v1 + 'report/index/product',
	},
	
	setting: {
		mall_config: api_root_v1 + 'mall/config',
		getScene: api_root_v1 + 'poster/get-share-content',
	},
	signIn: {
		signIn: api_root_v1 + 'user/sign-in/sign-in',
		signInAwardLog: api_root + 'sign-in/v1/default/award-log',
		signInRule: api_root_v1 + 'user/sign-in/sign-in-rule',
		signInIndex: api_root_v1 + 'user/sign-in/sign-in-index',
	},
}

function deep(obj) {
	for (let key in obj) {
		const value = obj[key]
		if (typeof value === "object") {
			deep(value)
		} else if (typeof value === "string") {
			const splitStr = "://"
			const arr = value.split(splitStr)
			if (arr[1]) {
				obj[key] = `${arr[0]}${splitStr}${cleanPath(arr[1])}`
			}
		}
	}
}

function cleanPath(path) {
	return path.replace(/\/+/g, '/')
}
deep(api)

module.exports = api;